import Vue from 'vue'
//@ts-ignore
import VueMapbox from 'vue-mapbox'
//@ts-ignore
import Mapbox from 'mapbox-gl'

Vue.use(VueMapbox, { mapboxgl: Mapbox })
